
export const useBase64 = () => {

  const utf8ToBase64 = (str: string): string => {
    return btoa(
      encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, (_, p1) => {
        return String.fromCharCode(parseInt(p1, 16));
      })
    );
  }

  const utf8ToBase64Url = (str: string): string => {
    return btoa(
      encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, (_, p1) => 
        String.fromCharCode(parseInt(p1, 16))
      )
    )
    .replace(/\+/g, '-')  // Reemplaza + por -
    .replace(/\//g, '_')  // Reemplaza / por _
    .replace(/=+$/, '');  // Elimina =
  };

  return {
    utf8ToBase64,
    utf8ToBase64Url
  }
}
